/**
* 头部菜单
*/ 
<template>
    <div style="background-color: #5f6a72;height: 38px;">
      <!-- <div style="display: flex;min-width: 1024px;margin: 0 auto;"> -->
      <div style="display: flex;min-width: 1024px;margin: 0 auto;">
        <!-- logo -->
        <div style="width: 60px;height: 38px;">
          <!-- <img src="../assets/img/favicon.png" style="width: 30px;height: 30px;margin-top: 2px;"> -->
        </div>
        <!-- 导航菜单 -->
        <div class="about-plus">
          <!-- <el-menu class="el-menu-demo" mode="horizontal" default-active="1" router :default-active="$route.path" background-color="#5f6a72" text-color="#fff" active-text-color="#fff">
            <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
              <template slot="title">
                <span>{{menu.menuname}}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
                  <span>{{chmenu.menuname}}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu> -->
          <el-menu  mode="horizontal" default-active="1" router :default-active="$route.path" background-color="#5f6a72" text-color="#fff" active-text-color="#fff">
          <template v-for="(items, index) in allmenu">
            <el-submenu :key="index" v-if="items.menus && items.menus.length > 0" :index="items.url">
              <template slot="title">
                  <span>{{ items.menuname }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item v-for="(item , i) in items.menus" :index="'/'+item.url" :key="i">
                  <span>{{item.menuname}}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item :key="index" v-else :index="'/'+items.url">
              <span>{{items.menuname}}</span>
            </el-menu-item>
          </template>
          </el-menu>
        </div>
        <!-- 个人中心 -->
        <div class="person-plus">
          <el-menu class="el-menu-demo" mode="horizontal" background-color="#5f6a72" text-color="#fff" active-text-color="#fff">
            <el-submenu index="2" class="submenu" :data="user">
              <template slot="title">{{ user.username }}</template>
              <el-menu-item @click="content()">个人中心</el-menu-item>
              <el-menu-item @click="exit()">退出</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
</template>
<script>
import { loginout } from '../api/userMG'
import Dept from '../views/system/Dept.vue'
import { menu } from '../api/userMG'
import { getAdminInfo } from '../api/patentMG'
import { checkLogin } from '../utils/util'

export default {
  components: { Dept },
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {
      },
      hiddenLogo : require('../assets/img/favicon.png'),
      allmenu: [],
      activeIndex: '1',
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.user = JSON.parse(localStorage.getItem('userdata'))

       // 获取图形验证码
    menu()
      .then(res => {
        res = checkLogin(res);
        if (res.code == 200) {
          this.allmenu = res.data.menu
          localStorage.setItem('path',JSON.stringify(res.data.path))
          console.log(this.allmenu)
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
      .catch(err => {
        this.$message.error('系统错误，请重新登录!')
      })
       // 查询账户信息
      getAdminInfo()
      .then(res => {
        if(res.code == 200) {
          this.user = res.data
        }else{
          console.log('用户信息查询失败!')
        } 
      })
      .catch(err => {
        this.$message.error('系统错误，请重新登录!')
      })
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('userdata');
            window.localStorage.removeItem('logintoken');
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
    // 个人中心
    content() {
      this.$router.push({ path: '/index/content' })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  /* height: 60px; */
  height: 38px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.el-menu.el-menu--horizontal {
    border-bottom: solid 0px #e6e6e6 !important;
}
.el-menu.el-menu--horizontal>.el-menu-item.is-active {
    /* border-bottom: 60px solid #2dbdd0 !important; */
    border-bottom: 38px solid #2dbdd0 !important;
    height: 38px;
}
.el-menu-item:hover {
  background-color: #2dbdd0 !important;
}
.is-opended:hover {
  background-color: #2dbdd0 !important;
}
header >>> .el-header.index-header {
  height: 38px !important;
}
.about-plus {
  min-width: 665px;
  height: 38px !important;
  line-height: 38px !important;
}
.about-plus >>> .el-menu-item {
  height: 38px;
  line-height: 38px !important;
}
.about-plus >>> .el-submenu__title {
   height: 38px;
   line-height: 38px !important;
}
.about-plus >>> .el-submenu__title:hover {
   background-color: #2dbdd0 !important;
}
.about-plus >>> .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
   /* border-bottom: 60px solid #2dbdd0 !important; */
   border-bottom: 38px solid #2dbdd0 !important;
   height: 38px;
}
.person-plus {
  margin-right: 15px;
  margin-left: auto;
}
.person-plus >>> .el-submenu__title:hover {
   background-color: #2dbdd0 !important;
}
.person-plus >>> .el-submenu__title {
   height: 38px;
   line-height: 38px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue